<template>
  <!-- Cada lado numa caixa, como as zonas do design da coleção: é onde ele mora que o título diz -->
  <div class="relationship-side-box">
    <div class="relationship-side-box-title">
      <span class="text-subtitle-2">{{ title }}</span>
      <span v-if="here" class="text-caption text-medium-emphasis">{{ $tt('relationship.this-side') }}</span>
    </div>
    <slot/>
  </div>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import Idea from '@/types/Idea'
import {within} from '@/utils/heading'

/**
 * A caixa de UM lado do relacionamento — "Em Canção · este lado", "Em Gênero musical" —, com o que é
 * daquele lado embaixo. As três abas da janela dividem a associação assim (pedido do usuário: "este lado"
 * e "o outro lado" valem para todas), e era a mesma caixa escrita em cada uma.
 */
@Component({name: 'ontos-relationship-side-box'})
class RelationshipSideBox extends Vue {
  @Prop({type: Object, required: true}) readonly idea!: Idea
  /** O lado em que a janela foi aberta. */
  @Prop({type: Boolean, default: false}) readonly here!: boolean
  /**
   * O nome do campo deste lado, nas abas em que ele não está à vista — Validação e Acessos (pedido do
   * usuário: não se sabia de qual campo eram as regras). Na Propriedade ele é o campo logo abaixo.
   */
  @Prop({type: String, default: ''}) readonly name!: string

  /** "Em Canção · Gênero", como o título da janela ("Canção · Gênero"), pelo mesmo `within`. */
  get title(): string {
    return within(this.$tt('relationship.in', {collection: this.idea.name}) as string, this.name)
  }
}

export default toNative(RelationshipSideBox)
</script>

<style scoped>
.relationship-side-box {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 16px 16px;
  border: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
  border-radius: 8px;
  min-width: 0;
}

.relationship-side-box-title {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
</style>
